import { adminEn } from './en/admin';
import { importQueueEn } from './en/import-queue';
import { sharedEn } from './en/shared';
import { sourceChannelsEn } from './en/source-channels';
import { adminRu } from './ru/admin';
import { importQueueRu } from './ru/import-queue';
import { sharedRu } from './ru/shared';
import { sourceChannelsRu } from './ru/source-channels';

export const appResources = {
  ru: {
    admin: adminRu,
    shared: sharedRu,
    'import-queue': importQueueRu,
    'source-channels': sourceChannelsRu,
  },
  en: {
    admin: adminEn,
    shared: sharedEn,
    'import-queue': importQueueEn,
    'source-channels': sourceChannelsEn,
  },
};
